const edgeCases = {
  generic: {
    name: 'generic',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Ha ocurrido un error',
    message: `Inténtelo nuevamente`,
    caseDataLayer: 'BORDE_GENERIC_ERROR',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  errorOcurred: {
    name: 'errorOcurred',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Ha ocurrido un error',
    message: `Inténtelo nuevamente`,
    caseDataLayer: 'BORDE_GENERIC_ERROR',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  errorOcurredStep2: {
    name: 'errorOcurredStep2',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Ha ocurrido un error',
    message: `Inténtelo nuevamente`,
    caseDataLayer: 'BORDE_GENERIC_TRANSVERSE_STEP_2',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  genericExitFlow: {
    name: 'genericExitFlow',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Deberás continuar con tu ingreso en nuestras sucursales',
    message: 'Necesitaremos pedirte algunos antecedentes adicionales para que puedas ingresar a la cooperativa. Para más información, contáctanos al 600 200 1200.',
    caseDataLayer: 'BORDE_GENERIC_ERROR_EXIT_FLOW',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  alreadyMember: {
    name: 'alreadyMember',
    icon: 'iconPersonError',
    title: '¡Importante! Ya eres Socio Coopeuch',
    message: `Según nuestros registros, ya eres parte de Coopeuch. Si deseas conocer más de la cooperativa, abrir una Cuenta Coopeuch y obtener su tarjeta de débito, dirígete a tu sitio privado.`,
    caseDataLayer: 'BORDE_ALREADY_MEMBER',
    blocker: true,
    redirect: 'privateSite',
    actionButton: {
      text: 'Ingresar al sitio privado',
      class: 'primary',
    },
  },
  customerWithUnpaidFees: {
    name: 'customerWithUnpaidFees',
    icon: 'iconPersonInfo',
    title: 'Identificamos que tienes un proceso de ingreso pendiente',
    message: 'Te invitamos a continuar en una sucursal de manera más personalizada con nuestros ejecutivos. Para más información, contáctanos al 600 200 1200.',
    caseDataLayer: 'BORDE_CUSTOMER_WITH_UNPAID_FEES',
    blocker: true,
    redirect: 'privateSite',
    actionButton: {
      text: '¡Entendido!',
      class: 'secondary',
    },
  },
  recentFormerPartner: {
    name: 'recentFormerPartner',
    icon: 'iconPersonInfo',
    title: '¡Importante! Tienes una renuncia reciente',
    message: `Detectamos que renunciaste como socio, por lo que estamos en un proceso interno de cierre. Podrás ingresar nuevamente el siguiente mes.`,
    caseDataLayer: 'BORDE_RECENT_FORMER_PARTNER',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  underage: {
    name: 'underage',
    icon: 'iconPersonWarning',
    title: 'Lo sentimos, debes ser mayor de 18 años',
    message: `Uno de los requisitos para pertenecer a la cooperativa es ser mayor de edad.`,
    caseDataLayer: 'BORDE_UNDERAGE',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  legalPerson: {
    name: 'legalPerson',
    icon: 'iconPersonInfo',
    title: 'El rut ingresado corresponde a una personalidad jurídica',
    message: `Debes registrarte como una persona natural para continuar tu proceso digital.
    Si necesitas ingresar como personalidad jurídica, puedes ir a cualquiera de nuestras sucursales.`,
    caseDataLayer: 'BORDE_LEGAL_PERSON',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  fatca: {
    name: 'fatca',
    icon: 'iconPersonInfo',
    title: 'Lo sentimos, debes continuar tu ingreso en una de nuestras sucursales',
    message: `Anteriormente, declaraste ser Estadounidense y/o pagar impuestos en un país fuera de Chile. Necesitamos más antecedentes para tu ingreso.`,
    caseDataLayer: 'BORDE_NO_TAXES_IN_CHILE',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  restrictedHours: {
    name: 'restrictedHours',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Por ahora no es posible continuar con la contratación',
    message: `Nos encontramos en cierre bancario todos los días de 23:00 a 03:00 hrs, por favor vuelve a intentarlo posterior a este horario.`,
    caseDataLayer: 'BORDE_RESTRICTED_HOURS',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  restrictionToForeigners: {
    name: 'restrictionToForeigners',
    icon: 'iconPersonInfo',
    title: 'Necesitamos conocerte más para continuar el proceso',
    message: 'Te invitamos a que sigas el ingreso en cualquiera de nuestras sucursales. Recuerda que uno de los requisitos para obtener tu Cuenta Vista Coopeuch es contar con residencia definitiva.',
    caseDataLayer: 'BORDE_FOREIGN',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: '¡Entendido!',
      class: 'secondary',
    },
  },
  notTaxesInChile: {
    name: 'notTaxesInChile',
    icon: 'notTaxesInChile',
    title: '¡Lo sentimos! No es posible continuar con el proceso',
    message: 'Para mas información, contáctanos al 600 200 12000.',
    caseDataLayer: 'BORDE_NO_TAXES_IN_CHILE',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  genericSignatureValidation: {
    name: 'genericSignatureValidation',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Ha ocurrido un error con la validacion del mensaje sms',
    message: `click en "reintentar" para obtener otro código`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  canNotShowElectronicSignature: {
    name: 'canNotShowElectronicSignature',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Ha ocurrido un error',
    message: `En estos momentos no es posible mostrar tu firmar electronica, por favor vuelve a intentarlo.`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Reintentar',
      class: 'primary',
    },
  },
  errorSurveyBecauseMember: {
    name: 'errorSurveyBecauseMember',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Ha ocurrido un problema',
    message: `En estos momentos no es posible mostrar los motivos de por qué te hiciste socio, por favor vuelve a intentarlo.`,
    caseDataLayer: '',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Reintentar',
      class: 'primary',
    },
  },
  errorSurveyAbandonment: {
    name: 'errorSurveyAbandonment',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Ha ocurrido un problema',
    message: `Se presentó un problema en el envío de respuesta, por favor reinténtelo`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Reintentar',
      class: 'primary',
    },
  },
  identityValidationExitFlow: {
    // COMMENT: por ahora no usado
    name: '    // COMMENT: por ahora no usado',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! No es posible continuar con el proceso',
    message: `Para mas información, contáctanos al 600 200 12000 o dirígete a una de nuestras sucursales.`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  identityValidationBlockingGenericError: {
    name: 'identityValidationBlockingGenericError',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Tu identidad no podrá ser validada por este medio',
    message: `Para continuar con el proceso de contratación, debes dirigirte a cualquiera de nuestras sucursales. Para más información, contáctanos al 600 200 1200.`,
    caseDataLayer: 'BORDE_IDENTITY_VALIDATION_OFFICE_REDIRECTION',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  identityValidationAttemptsExceeded: {
    name: 'identityValidationAttemptsExceeded',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! No ha sido posible validar tu identidad',
    message: `Has superado el número de intentos permitidos. Por tu seguridad podrás volver a intentalo dentro de 24hrs.`,
    caseDataLayer: 'BORDE_IDENTITY_VALIDATION_ATTEMPTS_EXCEEDED',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  identityValidationWrongAccount: {
    name: 'identityValidationWrongAccount',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Reingresa con tu ClaveÚnica',
    message: `Para validar tu identidad, debes ingresar con tu ClaveÚnica y responder las preguntas nuevamente.`,
    caseDataLayer: 'BORDE_IDENTITY_VALIDATION_RETRY',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  identityValidationNotAvailable: {
    name: 'identityValidationNotAvailable',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! ClaveÚnica no disponible',
    message: `No ha sido posible validar tu identidad. Por favor vuelve a intentarlo dentro de unas horas.`,
    caseDataLayer: 'BORDE_IDENTITY_VALIDATION_NOT_AVAILABLE',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  identityValidationRetry: {
    name: 'identityValidationRetry',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! No ha sido posible validar tu identidad',
    message: `Debes ingresar tu ClaveÚnica y responder las preguntas. El resto de tus datos han sido guardados correctamente.`,
    caseDataLayer: 'BORDE_IDENTITY_VALIDATION_RETRY',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  identityFacialBiometryError: {
    name: 'identityFacialBiometryError',
    icon: 'iconPersonBiometry',
    title: '¡Lo sentimos! Ha ocurrido un error con tu verificación de identidad',
    message: `Por favor vuelve a intentarlo.`,
    caseDataLayer: 'BORDE_IDENTITY_FACIAL_BIOMETRY_ERROR',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Reintentar',
      class: 'primary',
    },
  },
  identityFacialBiometryAttemptsExceeded: {
    name: 'identityFacialBiometryAttemptsExceeded',
    icon: 'iconPersonBiometryError',
    title: '¡Lo sentimos! No ha sido posible validar tu identidad',
    message: `Has superado el número de intentos permitidos. Por tu seguridad podrás volver a intentarlo dentro de 24hrs.`,
    caseDataLayer: 'BORDE_IDENTITY_FACIAL_BIOMETRY_ERROR',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  },
  successful: {
    name: 'successful',
    icon: 'iconPersonSuccess',
    title: '¡Muchas gracias por tu colaboración!',
    message: `Tus respuestas ha sido enviada con éxito.`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Volver a Coopeuch.cl',
      class: 'primary',
    },
  },
  infoAccountNumber: {
    name: 'infoAccountNumber',
    icon: 'infoAccountNumber',
    title: 'Número de cuenta',
    message: `Este es tu número de cuenta con el cual podrás realizar transacciones. Adicionalmente, también puedes ocupar tu rut sin puntos ni dígito verificador como número de cuenta. Utiliza el que prefieras.`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: '¡Entendido!',
      class: 'secondary',
    },
  },
  errorSendingOffer: {
    name: 'errorSendingOffer',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! No hemos podido crear tu solicitud de productos adicionales',
    message: `Para contratar cualquiera de estos productos contáctanos al 600 200 1200. Por el momento, te invitamos a ver tu comprobante de Socio con Cuenta Vista.`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Ir a comprobante',
      class: 'primary',
    },
  },
  errorCreatingSavingsAccount: {
    name: 'errorCreatingSavingsAccount',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! No ha sido posible contratar una Cuenta de Ahorro',
    message: `No te preocupes, puedes contratarla más adelante en tu sitio privado. Por el momento te invitamos a ver tu comprobante de Socio con Cuenta Vista.`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Ir a comprobante',
      class: 'primary',
    },
  },
  errorAttemptsExceededSmsCreatingSavingsAccount: {
    name: 'errorAttemptsExceededSmsCreatingSavingsAccount',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! No ha sido posible contratar una Cuenta de Ahorro',
    message: `Has excedido los intentos permitidos de ingreso de clave. No te preocupes, podrás contratar más adelante en tu sitio privado.`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Ir a comprobante',
      class: 'primary',
    },
  },
  errorTbkConnection: {
    name: 'errorTbkConnection',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Ha ocurrido un error',
    message: `Estamos teniendo inconvenientes para conectar con Webpay. Por favor, vuelve a intentarlo.`,
    caseDataLayer: 'BORDE_WP_CONECTION',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Reintentar',
      class: 'primary',
    },
  },
  errorPaymentDeclined: {
    name: 'errorPaymentDeclined',
    icon: 'iconPersonError',
    title: '¡Lo sentimos! Tu pago no se pudo procesar',
    message: `Te recomendamos esperar unos minutos y reintentar.`,
    caseDataLayer: '',
    blocker: false,
    redirect: 'none',
    actionButton: {
      text: 'Reintentar',
      class: 'primary',
    },
  },
  limitHorario: {
    name:'errorLimitHorario',
    icon:'iconPersonError',
    title:'Por ahora no es posible continuar\ncon la contratación',
    message:'Puedes realizarla entre 08:00 a 20:00 hrs.\nPor favor vuelve a intentarlo en ese horario.',
    caseDataLayer: 'BORDE_LEGAL_PERSON',
    blocker: true,
    redirect: 'publicSite',
    actionButton: {
      text: 'Entendido',
      class: 'secondary',
    },
  }
};

export default edgeCases;